import { extractBaseOrder } from './hash'

export const compareOrder = (
  a: string | { order: string },
  b: string | { order: string }
) => {
  const aOrder = typeof a === 'string' ? a : a.order
  const bOrder = typeof b === 'string' ? b : b.order

  // Extract base orders (without tiebreakers)
  const aBaseOrder = extractBaseOrder(aOrder)
  const bBaseOrder = extractBaseOrder(bOrder)

  // First compare base orders
  if (aBaseOrder < bBaseOrder) return -1
  if (aBaseOrder > bBaseOrder) return 1

  // If base orders are identical, use full order (with tiebreaker) to break ties
  return aOrder < bOrder ? -1 : aOrder > bOrder ? 1 : 0
}
